/// <reference path="skyward.ui.modallayer.js"/>
/// <reference path="skyward.ui.window.ts"/>
/// <reference path="skyward.ui.controls.ts"/>
/// <reference path="skyward.ui.fieldset.ts"/>
/// <reference path="skyward.ui.collapsepanel.js"/>

(
    function (skyward, $, undefined)
    {
        skyward.standardfilterviewer = skyward.standardfilterviewer || {};

        skyward.standardfilterviewer.clear = function (standardfilter)
        {
            standardfilter.find('.filterValue').each(function ()
            {
                if (!this.readOnly)
                {
                    skyward.controls.setValue(this, null);
                }
            });

            removeCollapsePanels(standardfilter);
        };

        skyward.standardfilterviewer.removeCollapsePanels = function (standardfilter)
        {
            removeCollapsePanels(standardfilter);
        };

        var addStandardFilterClick = function ()
        {
            var collapsePanel = $(this).closest(".collapsePanel");
            var panelData = collapsePanel.data();
            var promptUniqueID = panelData.promptUniqueId ?? panelData.skywardId;
            var standardFilterViewer = getStandardFilterViewer(collapsePanel);
            var data = getStandardFilterViewerData(standardFilterViewer);
            var viewerData = standardFilterViewer.data();
            var standardFilter = getStandardFilterByUniqueID(data.standardfilters, promptUniqueID);
            var newIndex = Math.max(...standardFilter.standardfilterindexes) + 1;
            var currentCount = standardFilter.standardfilterindexes.length;

            $.ajax({
                url: skyward.global.virtualDir + "SkySys/StandardFilter/AddStandardFilter",
                type: "POST",
                dataType: "JSON",
                success: function (data)
                {
                    insertStandardFilter(collapsePanel, data.html, data.standardfilterdata, promptUniqueID, newIndex, panelData.idPrefix);
                },
                data:
                {
                    currentCount: currentCount,
                    filterIndex: newIndex,
                    dataObjectType: standardFilter.type,
                    skywardID: standardFilter.skywardid,
                    relationshipPath: standardFilter.relationshippath,
                    promptValuesJson: JSON.stringify(data.values.promptboundvalues),
                    label: panelData.label,
                    promptUniqueID: promptUniqueID,
                    idPrefix: panelData.idPrefix,
                    defaultPromptsJson: JSON.stringify(viewerData.defaultPrompts),
                    readonlyIdsJson: JSON.stringify(viewerData.readonlyIds),
                    isRequired: viewerData.isRequired,
                    allowProcessingLists: standardFilter.allowprocessinglists
                }
            });
        };

        var removeStandardFilterClick = function ()
        {
            removeCollaspePanel($(this).closest(".collapsePanel"));
        };

        var removeCollapsePanels = function (standardfilter)
        {
            standardfilter.find(".collapsePanel").each(function ()
            {
                var collapsePanel = $(this);
                var panelData = collapsePanel.data();
                if (panelData.filterIndex > 0)
                {
                    removeCollaspePanel(collapsePanel);
                }
            });

        };

        var removeCollaspePanel = function (collapsePanel)
        {
            var standardFilterViewer = getStandardFilterViewer(collapsePanel);
            var panelData = collapsePanel.data();
            var panelPromptUniqueID = panelData.promptUniqueId;
            var filterIndex = panelData.filterIndex;

            if (filterIndex <= 0)
            {
                return;
            }

            const promptUniqueIDsToRemove = [];
            collapsePanel.find(".filterValue, .filterProcessingListValue").each(function ()
            {
                const prompt = $(this);
                const promptData = prompt.data();
                const promptUniqueID = promptData.promptUniqueId;
                promptUniqueIDsToRemove.push(promptUniqueID);
            });

            var panelIsDirty = skyward.changeTracking.isDirty(collapsePanel);
            var isNewFilter = collapsePanel.hasClass('newFilter');
            if (panelIsDirty && isNewFilter)
            {
                collapsePanel.remove();
                triggerUpdateDirtyFilter(collapsePanel, standardFilterViewer);
            }
            else
            {
                collapsePanel.find('.filterValue, .filterProcessingListValue').each(function ()
                {
                    triggerSavedFilterInputDirty($(this));
                });

                collapsePanel.remove();
            }

            var lastStandardFilterForUniqueID = standardFilterViewer.find(".collapsePanel[data-prompt-unique-id='" + panelPromptUniqueID + "']").last();
            var addButton = lastStandardFilterForUniqueID.find('.standardFilterAddButton');
            addButton.show();

            removeDataFromDataSource(standardFilterViewer, panelPromptUniqueID, filterIndex, promptUniqueIDsToRemove);
        };

        var getStandardFilterByUniqueID = function (standardFilters, uniqueID)
        {
            for (var i = 0; i < standardFilters.length; i++)
            {
                if (standardFilters[i].uniqueid == uniqueID)
                {
                    return standardFilters[i];
                }
            }
        };

        var getStandardFilterIndexByUniqueID = function (standardFilters, uniqueID)
        {
            for (var i = 0; i < standardFilters.length; i++)
            {
                if (standardFilters[i].uniqueid == uniqueID)
                {
                    return i;
                }
            }
        };

        var getStandardFilterViewerBackingData = function (container)
        {
            return container.find(".dataSource");
        };

        var getStandardFilterViewerData = function (container)
        {
            var backingData = getStandardFilterViewerBackingData(container);
            return JSON.parse(backingData.val());
        };

        var getStandardFilterViewer = function (container)
        {
            return container.closest(".standardFilterViewer");
        };

        var getStandardFilterID = function (idPrefix, skywardId, uniqueId, index)
        {
            var baseID = "standardfilter-" + skywardId + "-";
            if (uniqueId)
            {
                baseID = baseID + uniqueId + "-";
            }

            baseID = baseID + index;

            if (idPrefix)
            {
                return idPrefix + baseID;
            }

            return baseID;
        };

        var insertStandardFilter = function (collapsePanel, html, standardFilterData, uniqueId, newIndex, idPrefix)
        {
            var newFilter = $(html);
            newFilter.insertAfter(collapsePanel);
            var panelContents = collapsePanel.find(".collapsePanelContents");
            var panelData = collapsePanel.data();

            var addButton = panelContents.find(".standardFilterAddButton");
            addButton.hide();

            var standardFilterViewer = getStandardFilterViewer(collapsePanel);
            var dataSource = standardFilterViewer.find(".dataSource");

            addDataToDataSource(standardFilterData, dataSource, uniqueId);

            skyward.window.notifyDOMLoad("#" + getStandardFilterID(idPrefix, panelData.skywardId, uniqueId, newIndex));

            newFilter.each(initializeStandardFilter);

            newFilter[0].scrollIntoView();
            newFilter.find(".filterValue").first().focus();

            newFilter.ready(function ()
            {
                collapsePanel.trigger("standardFilterAdd", [newFilter]);
            });
        };

        var addDataToDataSource = function (standardfilterdata, backingData, promptUniqueID)
        {
            var newData = JSON.parse(standardfilterdata);
            var data = JSON.parse(backingData.val());
            var currentDataIndex = getStandardFilterIndexByUniqueID(data.standardfilters, promptUniqueID);
            var newDataIndex = getStandardFilterIndexByUniqueID(newData.standardfilters, promptUniqueID);
            data.standardfilters[currentDataIndex].standardfilterindexes = data.standardfilters[currentDataIndex].standardfilterindexes.concat(newData.standardfilters[newDataIndex].standardfilterindexes);
            $.extend(data.values.promptboundvalues, newData.values.promptboundvalues);
            backingData.val(JSON.stringify(data));
        };

        var removeDataFromDataSource = function (standardFilterViewer, promptUniqueID, filterIndex, promptUniqueIDsToRemove)
        {
            const data = getStandardFilterViewerData(standardFilterViewer);
            const backingData = getStandardFilterViewerBackingData(standardFilterViewer);

            for (const promptUniqueID of promptUniqueIDsToRemove)
            {
                if (data.values.promptboundvalues?.hasOwnProperty(promptUniqueID))
                {
                    delete data.values.promptboundvalues[promptUniqueID];
                }
            }

            const standardFilter = getStandardFilterByUniqueID(data.standardfilters, promptUniqueID);
            standardFilter.standardfilterindexes = standardFilter.standardfilterindexes.filter(function (index) { return index != filterIndex });
            if (standardFilter.standardfilterindexes.length <= 0)
            {
                standardFilter.standardfilterindexes = [1];
            }

            backingData.val(JSON.stringify(data));
        };

        var triggerUpdateDirtyFilter = function (collapsePanel, standardFilterViewer)
        {
            var dirtyElements = collapsePanel.find('[data-dirty]');

            if (dirtyElements.length > 0)
            {
                $.each(dirtyElements, function ()
                {
                    $(this).removeAttr("data-dirty");
                });
            }

            var filterInputToTrigger = standardFilterViewer.find('.filterValue').eq(0);
            var isWorkflow = standardFilterViewer.parent().hasClass("workflowContent");
            filterInputToTrigger.trigger(isWorkflow ? 'update' : 'change');
        };

        var triggerSavedFilterInputDirty = function (element)
        {
            var currentValue = element.val();
            if (element.is("[ignoredirtyfieldcomparison]") || currentValue == "" || currentValue == "{}" || currentValue == "[]")
            {
                return;
            }

            if (element.hasClass('comboBoxSet'))
            {
                skyward.controls.setValue(element, "", false);
            }
            else if (element.hasClass('multiSelectBackingData'))
            {
                skyward.multipleselectbox.populate(element, [], true);
            }
            else if (element.hasClass('dmsBackingData'))
            {
                skyward.controls.setValue(element, "{}", false);
            }
            else
            {
                skyward.controls.setValue(element, "true", false);
            }
        };

        var changeAdvancedFilterData = function (container)
        {
            var advancedFilter = container.find(".filterViewValue");
            var backingData = getStandardFilterViewerBackingData(container);
            var data = JSON.parse(backingData.val());

            var advancedFilterData = advancedFilter.data("filterCondition");
            data.values.advancedfilter = advancedFilterData;
            backingData.val(JSON.stringify(data));
        };

        var changeFilterValue = function (origFilter, container)
        {
            var backingData = getStandardFilterViewerBackingData(container);
            var data = JSON.parse(backingData.val());
            var filter = $(origFilter);

            var uniqueId = filter.data("promptUniqueId").toLowerCase();
            data.values.promptboundvalues = data.values.promptboundvalues || {};
            var filterValue = skyward.controls.getUnencodedValue(filter);

            if (skyward.promptsview.isNonEmptyPromptValue(filterValue))
            {
                data.values.promptboundvalues[uniqueId] = filterValue;
            }
            else
            {
                delete data.values.promptboundvalues[uniqueId];
            }
            backingData.val(JSON.stringify(data));
        };

        var initializeStandardFilterViewer = function ()
        {
            var container = $(this);
            container.removeClass("standardFilterViewerUnbound");

            var backingData = container.find(".dataSource");
            var data = JSON.parse(backingData.val());
            data.values = data.values || {};
            data.values.promptboundvalues = data.values.promptboundvalues || {};
            backingData.data("currentValue", data);

            container.on("change", ".filterViewValue", null, function ()
            {
                changeAdvancedFilterData(container);
            });
            container.on("change dirty", ".filterValue, .filterProcessingListValue", null, function ()
            {
                changeFilterValue(this, container);
            });
            container.on("click", ".standardFilterAddButton", null, addStandardFilterClick);
            container.on("click", ".standardFilterRemoveButton", null, removeStandardFilterClick);
        };

        var initializeStandardFilter = function ()
        {
            var standardFilter = $(this);
            standardFilter.removeClass("standardFilterViewerUnbound");
            standardFilter.on("change dirty", ".filterValue, .filterProcessingListValue", null, skyward.promptsview.setModifiedNotification);
            standardFilter.each(skyward.promptsview.setModifiedNotification);
        };

        var initializeAdvancedFilter = function ()
        {
            var advancedFilter = $(this);
            advancedFilter.removeClass("advancedFilterUnbound");
            advancedFilter.on("change dirty", ".filterViewValue", null, skyward.promptsview.setModifiedNotification);
            advancedFilter.each(skyward.promptsview.setModifiedNotification);
        };

        var init = function (selector)
        {
            selector = $(selector);
            selector.find(".standardFilterViewerUnbound").each(initializeStandardFilterViewer);
            selector.find(".standardFilterPromptsUnbound").each(initializeStandardFilter);
            selector.find(".advancedFilterUnbound").each(initializeAdvancedFilter);
        };

        skyward.window.registerLoadDOMCallback(init);

    })(skyward || {}, jQuery);